// extracted by mini-css-extract-plugin
export var pTags = "nh";
export var animationMarquee = "oh";